import { render, staticRenderFns } from "./CampaignIndex.vue?vue&type=template&id=6b6b5b7e&scoped=true&"
import script from "./CampaignIndex.vue?vue&type=script&lang=js&"
export * from "./CampaignIndex.vue?vue&type=script&lang=js&"
import style0 from "./CampaignIndex.vue?vue&type=style&index=0&id=6b6b5b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b5b7e",
  null
  
)

export default component.exports